import React from "react";

const Loader = () => {
  return (
    <div className="loading-area">
      <div className="loading-box" />
      <div className="loading-pic">
        <img
          src={require("../../images/logo-1.png")}
          className="splashLogo"
        />
		<div className="loading-div">
			Loading...
		</div>
      </div>
    </div>
  );
};

export default Loader;
